import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class MaterialDisplayIconFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        return {
            getLabelText: () => {
                if (item?.data?.elementType === 'EnumerationSensor') {
                    return item.name || item.displayValue;
                }
                return item.displayValue || item.name;
            },
            getUnits: () => {
                if (item && item.numberSensorInputMap) {
                    return item.numberSensorInputMap.units;
                }
                return '';
            },
            materialIcon: item.graphicBehavior as string,
            isLabelVisible: () => true,
            getValue: () => item.displayValue || item.value
        };
    }
}
